var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{staticClass:"modal--request pay-modal",attrs:{"title":"Оплата"},on:{"close":function($event){return _vm.$emit('close')}}},[_vm._v(" Здесь форма ")])
}
var staticRenderFns = []

export { render, staticRenderFns }